export default __webpack_public_path__ + "static/media/Mask Group 31.0bb2ba4d.svg";